<template>
    <article>
        <h1>Ganesha Dx</h1>
        <h3>2021 - Present</h3>

        <section>
            <div class="links">
                <p>
                    <a href="https://github.com/Garmichael/GaneshaDx/releases" target="_blank">Download Ganesha Dx</a> |
                    <a href="https://www.youtube.com/playlist?list=PLh_iA7J_8dx3XcC5xZU3MkRoYFrsLOe0D" target="_blank">
                        Video Tutorial Series
                    </a>
                </p>
            </div>

            <div class="two-columns">
                <div>
                    <img src="../assets/page-ganesha-dx/screenshot.png" alt="Ganesha Dx Screenshot">
                </div>

                <div>
                    <p>
                        Ganesha Dx is a full featured map editor for the Playstation version of Final Fantasy Tactics.
                    </p>
                    <p>
                        You can try it out with maps copied from your FFT PSX disc or use
                        <router-link to="/FFTMaps">my maps</router-link>
                        .
                    </p>
                </div>
            </div>
        </section>

        <h2>About the Development of Ganesha Dx</h2>
        <h3>C#, MonoGame, ImGui, Hex Editing</h3>

        <section>
            <div class="links">
                <p>
                    <a href="https://github.com/Garmichael/GaneshaDx" target="_blank">
                        Ganesha Dx Source Code on GitHub
                    </a>
                </p>
            </div>

            <div class="one-column">
                <p>
                    In some down time, I had gotten into a twitch channel called FFTBattleground, which streams AI
                    battles between two teams while chat members bet on which team would win. The maps were designed for
                    the single player campaign and often favored one team over another. This inspired me to make my own
                    map that was balanced and submit it to the developer of the channel.
                </p>
                <p>
                    The existing tool was called Ganesha, written in Python 1.3 in 2010, lacked a lot of functional and
                    quality of life features, and ran slow and use was clunky. Simple tasks like polygon placement,
                    texturing, and normal alignment took hours. Because of this, the map editing scene never really took
                    off and was generally regarded as infeasible.
                </p>
                <p>
                    So, in middle of working on my new map, I started developing Ganesha Dx. While it honors the name of
                    the original project, Ganesha Dx is built from scratch using Monogame and ImGui. My goal with this
                    project was to build a map editor that was easy to use and included the functionality that the
                    original program lacked.
                </p>
                <p>
                    While many of the basic features of the proprietary map format were already documented, just as many
                    features were yet to be discovered. Through this project, I investigated and discovered how the map
                    format encoded Palette Animations, UV Animations, Animated Meshes, Rotation Angles, Time and Weather
                    states, and some aspects of Lighting. Decoding this format took weeks. I then incorporated these
                    features into Ganesha Dx, allowing map creators to finally create and modify aspects of maps they
                    had never been able to. Many members of that community have thanked me often about my contributions
                    to the scene.
                </p>
                <p>
                    Aside from having to decode large chunks of unknown data in the map format, challenges included
                    learning Monogame, brushing up on 3D math, writing a shader that handled the specific way the game
                    interpreted lighting, and designing an intuitive and simple UI that covers all of the complexity
                    and options that make up the maps.
                </p>
            </div>
        </section>


    </article>
</template>

<script>
    export default {
        name: "GaneshaDx"
    }
</script>